import PropTypes from 'prop-types'
import GhostContentAPI from '@tryghost/content-api'
const Topthree = ({ id }) => {
    const api = new GhostContentAPI({
        url: `https://vfitblog.vantagefit.io`,
        key: `618b7655cbd5ad6d6a1bd174e8`,
        version: `v3`,
    })
    api.posts
        .browse({ limit: 4, include: `tags,authors` })
        .then((res) => {
            var blogurl =`https://www.vantagefit.io/en/blog/`
            appenddata(res,blogurl)
        })
        .catch((err) => {
            console.error(err)
        })
    return (
        <div className="row" id="topthree">
        </div>

    )

}

function appenddata(data,blogurl){
    var info = document.getElementById(`topthree`)
    var template = ``

    for (var i = 0; i < data.length; i++){
        if(data[i].tags[0].name !== "#Podcasts"){
        template += `<div class="col-md-4 col-lg-4 col-sx-12 col-sm-4 d-left">
            <div class="box-shadow shadowN">
                <div class="overflow">
                    <a href="`+blogurl+data[i].slug+`" target="_blank" rel="noopener noreferrer">
                        <img width="377" height="181" class="img-responsive ease lozad" src="`+ data[i].feature_image+`" alt="blog" loading ="lazy"/>
                    </a>
                </div>
                <a href="`+blogurl+data[i].slug+`" target="_blank" rel="noopener noreferrer">
                    <div class="post_titel">
                        `+ data[i].title +`
                    </div>
                </a>
                <a href="`+blogurl+data[i].slug+`" target="_blank" rel="noopener noreferrer">
                    <div class="blog_excerpt">`+ data[i].excerpt +`
                    </div>
                </a>
                <div class=" flw100 blogP">
                <a href="`+blogurl+data[i].slug+`" title="Employee Health" class="links"  target="_blank" rel="noopener noreferrer">
                Read More <span class="campaignSprite"></span></a></div>
            </div>
        </div>`
        }
    }
    info.innerHTML = template
}
Topthree.propTypes = {
    id: PropTypes.string,
}

export default Topthree
